import React from 'react';
import PropTypes from 'prop-types';
import { PopupTitle, PopupFooter } from 'new-ui/Components/Popup';
import Button from 'new-ui/Components/Button';
import { useTranslation } from 'utils/modifiedTranslation';
import { POPUP } from 'utils/constants/popup';
import app from 'new-ui/app';

import './Questions.css';

const Questions = (props) => {
  const { questions } = props;
  const { t } = useTranslation();

  const onQuestionAnswered = async (questionDone, notFound) => {
    if (!notFound) {
      app.showPreloader();
      await app.requestRematch();
      app.hidePreloader();
    }

    if (questionDone) {
      questions.splice(questions.indexOf(questionDone), 1);
      if (!questions.length) {
        app.closePopups();
        return;
      }
      app.openPopup(POPUP.QUESTIONS, { questions });
    }
  };

  const editQuestion = (question) => {
    app.editQuestion([question], ({ notFound }) => {
      onQuestionAnswered(question, notFound);
    });
  };

  const updateAll = () => {
    const spentQuestionIds = new Set();
    const notFoundQuestionIds = new Set();

    const questionsCount = new Set(questions).size;

    app.editQuestion(questions, ({ questionId, notFound }) => {
      spentQuestionIds.add(questionId);
      if (notFound) {
        notFoundQuestionIds.add(questionId);
      }

      if (notFoundQuestionIds.size === questionsCount) {
        app.closePopups();
      } else if (spentQuestionIds.size === questionsCount) {
        app.closePopups();
        (async () => {
          app.showPreloader();
          await app.requestRematch();
          app.hidePreloader();
        })();
      } else if (!notFound) {
        app.requestRematch();
      }
    });
  };

  return (
    <div className="questions-popup">
      <PopupTitle title={t('questions_popup.title')} />
      {
        questions.map((q, i) => (
          <div key={i} className="question" onClick={() => { editQuestion(q); }}>
            <div className="question-circle">{i + 1}</div>
            <div className="question-title">{t(`missing_critical.question.${q}`)}</div>
          </div>
        ))
      }
      <PopupFooter>
        <Button title={t('questions_popup.button')} action={updateAll} />
      </PopupFooter>
    </div>
  );
};

Questions.propTypes = {
  questions: PropTypes.array,
};

export default Questions;
